<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-orange-400 hover:text-orange-600" href="/oficinas">Oficinas</Link>
      <span class="text-orange-400 font-medium">/</span>
      {{ form.name }}
    </h1>
    <trashed-message v-if="organization.deleted_at" class="mb-6" @restore="restore"> Esta organización ha sido eliminada. </trashed-message>
    <div class="2xl:flex">
      <div class="w-full min-w-3xl bg-white rounded-md shadow overflow-hidden">
        <form class="flex flex-col justify-between" @submit.prevent="update">
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.name" :disabled="auth.user.role_id != 1" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
            <text-input v-model="form.area_manager" :disabled="auth.user.role_id != 1" :error="form.errors.area_manager" class="pb-8 pr-6 w-full lg:w-1/2" label="Area Manager" />
            <text-input v-model="form.consultant" :disabled="auth.user.role_id != 1" :error="form.errors.consultant" class="pb-8 pr-6 w-full lg:w-1/2" label="Consultor" />
            <text-input v-model="form.codeBDT" :disabled="auth.user.role_id != 1" :error="form.errors.codeBDT" class="pb-8 pr-6 w-full lg:w-1/2" label="Código BDT" />
            <text-input v-model="form.email" :disabled="auth.user.role_id != 1" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" />
            <text-input v-model="form.phone" :disabled="auth.user.role_id != 1" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Teléfono" />
            <text-input v-model="form.address" :disabled="auth.user.role_id != 1" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Dirección" />
            <text-input v-model="form.city" :disabled="auth.user.role_id != 1" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="Ciudad" />
            <text-input v-model="form.region" :disabled="auth.user.role_id != 1" :error="form.errors.region" class="pb-8 pr-6 w-full lg:w-1/2" label="Provincia" />
            <text-input v-model="form.zone" :disabled="auth.user.role_id != 1" :error="form.errors.zone" class="pb-8 pr-6 w-full lg:w-1/2" label="Zona" />
            <select-input v-model="form.country" :disabled="auth.user.role_id != 1" :error="form.errors.country" class="pb-8 pr-6 w-full lg:w-1/2" label="País">
              <option value="ES">España</option>
            </select-input>
            <text-input v-model="form.postal_code" :disabled="auth.user.role_id != 1" :error="form.errors.postal_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Código postal" />
          </div>
          <div v-if="auth.user.role_id == 1" class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
            <button v-if="!organization.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Eliminar oficina</button>
            <loading-button :loading="form.processing" class="btn-orange ml-auto" type="submit">Actualizar oficina</loading-button>
          </div>
        </form>
      </div>
      <div class="w-full py-4 2xl:px-4 mt-8 2xl:mt-0 pt-0">
        <div class="px-8 py-4 shadow rounded-t bg-gray-50 border-t border-gray-100 flex">
          <h2 class="text-2xl font-bold">Códigos asociados</h2>
          <Link v-if="auth.user.role_id == 1" class="btn-orange ml-auto" :href="`/codigos/${organization.id}/crear`">Añadir código</Link>
        </div>
        <div class="bg-white rounded-b shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <thead>
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6">Nombre</th>
                <th class="pb-4 pt-6 px-6">Razón social</th>
              </tr>
            </thead>
            <tr v-for="code in organization.codes" :key="code.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t">
                <div v-if="auth.user.role_id != 1" class="flex items-center px-6 py-4 focus:text-orange-500">
                  {{ code.name }}
                </div>
                <Link v-if="auth.user.role_id == 1" class="flex items-center px-6 py-4 focus:text-orange-500" :href="`/codigos/${organization.id}/editar/${code.id}`">
                  {{ code.name }}
                </Link>
                <icon v-if="code.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </td>
              <td class="border-t">
                <div v-if="auth.user.role_id != 1" class="flex items-center px-4">
                  {{ code.business_name }}
                </div>
                <Link v-if="auth.user.role_id == 1" class="flex items-center px-4" :href="`/codigos/${organization.id}/editar/${code.id}`" tabindex="-1">
                  {{ code.business_name }}
                </Link>
              </td>
              <td class="w-px border-t">
                <div v-if="auth.user_role_id != 1" class="flex items-center px-4" />
                <Link v-if="auth.user.role_id == 1" class="flex items-center px-4" :href="`/codigos/${organization.id}/editar/${code.id}`" tabindex="-1">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="organization.codes.length === 0">
              <td class="px-6 py-4 border-t" colspan="4">No se han encontrado códigos.</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="w-full py-4 px-0 mt-4 pt-0">
      <div class="px-8 py-4 shadow rounded-t bg-gray-50 border-t border-gray-100">
        <h2 class="text-2xl font-bold">Empleados asociados</h2>
      </div>
      <div class="bg-white rounded-b shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <thead>
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6">Nombre</th>
              <th class="pb-4 pt-6 px-6">Email</th>
              <th class="pb-4 pt-6 px-6" colspan="2">Rol</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="user in organization.users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link class="flex items-center px-6 py-4 focus:text-orange-500" :href="`/usuarios/${user.id}/editar`">
                  {{ user.name }}
                  <icon v-if="user.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/usuarios/${user.id}/editar`" tabindex="-1">
                  {{ user.email }}
                </Link>
              </td>
              <td class="border-t">
                <Link class="flex items-center px-6 py-4" :href="`/usuarios/${user.id}/editar`" tabindex="-1">
                  {{ user.role.name }}
                </Link>
              </td>
              <td class="w-px border-t">
                <Link class="flex items-center px-4" :href="`/usuarios/${user.id}/editar`" tabindex="-1">
                  <icon v-if="auth.user.role_id == 1" name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </Link>
              </td>
            </tr>
            <tr v-if="organization.users.length === 0">
              <td class="px-6 py-4 border-t" colspan="4">No se han encontrado empleados.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="w-full py-4 px-0 mt-4 pt-0">
      <div class="px-8 py-4 shadow rounded-t bg-gray-50 border-t border-gray-100">
        <h2 class="text-2xl font-bold">Formularios</h2>
      </div>
      <div class="bg-white rounded-b shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-left font-bold">
            <th class="pb-4 pt-6 px-6">Fecha</th>
            <th class="pb-4 pt-6 px-6">Entrega</th>
            <th class="pb-4 pt-6 px-6">Editado por</th>
          </tr>
          <tr v-for="formEntry in organization.forms" :key="formEntry.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <Link class="flex items-center px-6 py-4 focus:text-orange-500" :href="`/formularios/${formEntry.id}/editar`">
                {{ formatDate(formEntry.form_date) }}
                <icon v-if="formEntry.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                <span v-if="formEntry.active == '0'" class="px-4 py-2 rounded-full text-green-500 bg-green-200 font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease">
                  Formulario entregado
                </span>
                <span v-if="formEntry.active == '1'" class="px-4 py-2 rounded-full text-red-500 bg-red-200 font-semibold text-sm flex align-center w-max cursor-pointer active:bg-gray-300 transition duration-300 ease">
                  Formulario sin entregar
                </span>
              </Link>
            </td>
            <td class="border-t">
              <Link class="flex items-center px-6 py-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                {{ formEntry.user ? getUserName(formEntry.user) : '-' }}
              </Link>
            </td>
            <td class="w-px border-t">
              <Link class="flex items-center px-4" :href="`/formularios/${formEntry.id}/editar`" tabindex="-1">
                <icon v-if="auth.user.role_id == 1" name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
              </Link>
            </td>
          </tr>
          <tr v-if="organization.forms.length === 0">
            <td class="px-6 py-4 border-t" colspan="4">No se han encontrado formularios.</td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    organization: Object,
    organizations: Array,
    auth: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.organization.name,
        area_manager: this.organization.area_manager,
        consultant: this.organization.consultant,
        codeBDT: this.organization.codeBDT,
        email: this.organization.email,
        phone: this.organization.phone,
        address: this.organization.address,
        city: this.organization.city,
        region: this.organization.region,
        country: this.organization.country,
        postal_code: this.organization.postal_code,
        zone: this.organization.zone,
      }),
    }
  },
  methods: {
    getUserName(user) {
      return user.first_name
    },
    formatDate(date) {
      return new Date(date).toLocaleDateString('es-ES', { month: '2-digit', year: 'numeric' })
    },
    update() {
      this.form.put(`/oficinas/${this.organization.id}`)
    },
    destroy() {
      if (confirm('¿Estas seguro que quieres eliminar esta oficina?')) {
        this.$inertia.delete(`/oficinas/${this.organization.id}`)
      }
    },
    restore() {
      if (confirm('¿Estas seguro que quieres restaurar esta oficina?')) {
        this.$inertia.put(`/oficinas/${this.organization.id}/restaurar`)
      }
    },
  },
}
</script>
